import React, { useCallback, useMemo } from 'react'

import { Box, Heading, Stack, Text } from '@chakra-ui/react'
import { FieldArray, useField } from 'formik'
import { useSelector } from 'react-redux'

import Constituent from './Constituent'
import { convertDistrictToNumeric, hasPermission } from '../../../../utils'
import { ConstituentSelect } from '../../../ui/select'

const AddRemoveConstituents = () => {
  const user = useSelector(state => state.auth.user)
  const [field, ,] = useField('constituents')
  const { value: constituents } = field

  const removeConstituent = useCallback(
    (index, remove, replace) => {
      if (constituents[index].status === 'new') {
        return remove(index)
      }

      let updatedConstituent = { ...constituents[index] }
      if (constituents[index].status === 'removed') {
        updatedConstituent.status = undefined
        return replace(index, updatedConstituent)
      }

      updatedConstituent.status = 'removed'
      return replace(index, updatedConstituent)
    },
    [constituents]
  )

  const selectedConstituents = useMemo(
    () =>
      constituents?.map(c => ({
        label: c.name,
        value: c,
      })) || [],
    [constituents]
  )

  const districtFilter =
    hasPermission(user, 'directory.constituent.view_all_constituents') &&
    constituents.length > 0
      ? constituents[0].district
      : undefined

  return (
    <Box mt={3} w='100%'>
      <Box mb={2}>
        <Heading size='sm' color='blue.500'>
          Add/Remove Constituents
        </Heading>
        {districtFilter && (
          <Text variant='subheading-sm'>
            Constituent choices are limited to district
            {convertDistrictToNumeric(districtFilter)}.
          </Text>
        )}
      </Box>

      <FieldArray name='constituents'>
        {({ unshift, remove, replace }) => (
          <>
            <ConstituentSelect
              inputProps={{
                id: 'add-constituent-select',
                placeholder: 'Search for a constituent',
              }}
              filters={{ district: districtFilter }}
              initialSelected={selectedConstituents}
              enableClear={false}
              onSelect={constituent =>
                unshift({ ...constituent, status: 'new', role: '' })
              }
              showTags={false}
            />

            <Stack maxH='50vh' overflowY='auto' my={2}>
              {constituents?.map((c, index) => (
                <Constituent
                  {...c}
                  key={index}
                  index={index}
                  onClick={() => removeConstituent(index, remove, replace)}
                />
              ))}
            </Stack>
          </>
        )}
      </FieldArray>
    </Box>
  )
}

export default AddRemoveConstituents
